import { post } from '../utils'

export const exchangeToken = token => {
    return post('/token/exchange', {
        body: token,
    })
}
